/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExpenseResource } from './';
import {
    ExpenseResourceFromJSON,
    ExpenseResourceFromJSONTyped,
    ExpenseResourceToJSON,
} from './';
import type { ExpenseSummary } from './';
import {
    ExpenseSummaryFromJSON,
    ExpenseSummaryFromJSONTyped,
    ExpenseSummaryToJSON,
} from './';
import type { PunchoutDetails } from './';
import {
    PunchoutDetailsFromJSON,
    PunchoutDetailsFromJSONTyped,
    PunchoutDetailsToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExpenseListForApprovalResource
 */
export interface ExpenseListForApprovalResource {
    /**
     * 
     * @type {string}
     * @memberof ExpenseListForApprovalResource
     */
    clientPurchaseOrder?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExpenseListForApprovalResource
     */
    clientPurchaseOrderRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExpenseListForApprovalResource
     */
    batchQuoteId?: string;
    /**
     * 
     * @type {ExpenseSummary}
     * @memberof ExpenseListForApprovalResource
     */
    summary: ExpenseSummary;
    /**
     * 
     * @type {Array<ExpenseResource>}
     * @memberof ExpenseListForApprovalResource
     */
    expenses: Array<ExpenseResource>;
    /**
     * 
     * @type {PunchoutDetails}
     * @memberof ExpenseListForApprovalResource
     */
    punchoutDetails?: PunchoutDetails;
}

/**
 * Check if a given object implements the ExpenseListForApprovalResource interface.
 */
export function instanceOfExpenseListForApprovalResource(value: object): value is ExpenseListForApprovalResource {
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('expenses' in value) || value['expenses'] === undefined) return false;
    return true;
}

export function ExpenseListForApprovalResourceFromJSON(json: any): ExpenseListForApprovalResource {
    return ExpenseListForApprovalResourceFromJSONTyped(json, false);
}

export function ExpenseListForApprovalResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpenseListForApprovalResource {
    if (json == null) {
        return json;
    }
    return {
        
        'clientPurchaseOrder': json['clientPurchaseOrder'] == null ? undefined : json['clientPurchaseOrder'],
        'clientPurchaseOrderRequired': json['clientPurchaseOrderRequired'] == null ? undefined : json['clientPurchaseOrderRequired'],
        'batchQuoteId': json['batchQuoteId'] == null ? undefined : json['batchQuoteId'],
        'summary': ExpenseSummaryFromJSON(json['summary']),
        'expenses': ((json['expenses'] as Array<any>).map(ExpenseResourceFromJSON)),
        'punchoutDetails': json['punchoutDetails'] == null ? undefined : PunchoutDetailsFromJSON(json['punchoutDetails']),
    };
}

export function ExpenseListForApprovalResourceToJSON(value?: ExpenseListForApprovalResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientPurchaseOrder': value['clientPurchaseOrder'],
        'clientPurchaseOrderRequired': value['clientPurchaseOrderRequired'],
        'batchQuoteId': value['batchQuoteId'],
        'summary': ExpenseSummaryToJSON(value['summary']),
        'expenses': ((value['expenses'] as Array<any>).map((v) => ExpenseResourceToJSON(v))),
        'punchoutDetails': PunchoutDetailsToJSON(value['punchoutDetails']),
    };
}

